import Vue from 'vue';

const success = (data, context) => {
  context.openPaymentPanel(data.globalPayment);
};

const failed = (context, error) => {
  context.showToasterError(error);
};

export default (context, permalink) => Vue.$http.get(`create-global-payment/${permalink}`)
.then((response) => {
  if (response.status === 200) {
    success(response.data, context);
  }
})
.catch((error) => {
  failed(context, error);
});



// WEBPACK FOOTER //
// ./src/app/services/payment/createGlobalPayment.js